<template>
  <div>
    <div class="title"></div>
    <div class="main">
      <el-row>
        <el-col :span="12">
          <div class="form-item">
            <div class="label">
              公司名称
            </div>
            <div class="value">
              {{form.componeny}}
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="form-item">
            <div class="label">
              状态
            </div>
            <div class="value">
              {{form.status}}
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="form-item">
            <div class="label">
              联系人
            </div>
            <div class="value">
              {{form.name}}
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="form-item">
            <div class="label">
              联系方式
            </div>
            <div class="value">
              {{form.tel}}
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <div class="form-item">
          <div class="label">
            需求描述
          </div>
          <div class="value">
            {{form.detail}}
          </div>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'demandInfo', // 需求信息
  data () {
    return {
      form: {
        componeny: '',
        status: '',
        name: '',
        tel: '',
        detail: ''
      }
    }
  }
}
</script>

<style>

</style>
